import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./fieldContext";
import { resolveTagTone } from "./tagTone";

export interface StatusTextProps extends Omit<HTMLAttributes<HTMLSpanElement>, "color"> {
  children?: ReactNode;
  /** Ton wie bei `Tag` (Kit-Ton oder Antd-Name: success, warning, error, processing …). */
  color?: string;
}

/**
 * Ruhige Statusanzeige in Listen und Köpfen: farbiger Punkt plus Text, ohne Etikettenrahmen (DNA D29).
 * Für Abweichungen vom Normalzustand; der Normalzustand selbst bekommt keine Anzeige.
 */
export function StatusText({ children, color, className, ...rest }: StatusTextProps) {
  return (
    <span className={cx("ck-status-text", className)} data-tone={resolveTagTone(color) ?? "neutral"} {...rest}>
      {children}
    </span>
  );
}
